import logo from './logo.svg';
import './App.css';
import Header from './Pages/Head';
import About from './Pages/About';
import Services from './Pages/Services';
import Contact from './Pages/Contacts';
import { analytics } from './firebase.inf';

function App() {
  return (
    <div className="App">
      <Header/>
      
       <About/>

       <Services/>

       <Contact/>
      
    </div>
  );
}

export default App;
